import { Directive, EventEmitter, HostListener, Output } from '@angular/core';


/**------------------------------------------------------
 * Paste Text
 * ----------
 * Paste text from clipboard
 *
 * Example:
 * --------
 * 	<i [ngPaste]="..."> ... </i>
 */
@Directive({
    selector: '[ngPaste]',
    standalone: false
})
export class NgPasteDirective {

	@Output() readonly pasteSuccess	: EventEmitter<string> = new EventEmitter<string>();
	@Output() readonly pasteFail	: EventEmitter<string> = new EventEmitter<string>();

	@HostListener('click', ['$event'])
	public onClick(event: Event): void {

		//0 - prevent propagating from
		event.stopPropagation();

		//1 - write on the clipboard
		navigator.clipboard.readText()
			.then((clipText: string) => {
				this.pasteSuccess.emit(clipText);
			})
			.catch((error: any) => {
				this.pasteFail.emit(error);
			});
	}
}
